import React, { Component } from 'react';
import styled from 'styled-components';

import $ from 'jquery';

import css from 'css';

import { isValidEmail, msg } from 'helpers';

import { Input, TextArea, Select } from 'partials/formElements';
import Html from 'partials/Html';
import Container from 'partials/Container';

const Form = styled.form`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 0 auto 30px auto;
    order: 2;

    @media (min-width: 767px) {
        order: 1;
    }

    &.has-sidebar {
        @media (min-width: 767px) {
            width: 70%; 
            padding-right: 20px;
        }
    }
`;

const Sidebar = styled.div`
    width: 100%;
    padding-right: 0;
    display: flex;
    order: 1;
  
    @media(min-width: 767px) {
        order: 2;
        width: 30%;
        padding-left: 20px;
    }
`;

const InputRow = styled.div`
    display: flex;
    flex-flow: column;
    width: 100%;
    margin-bottom: 30px;

    .input-wrapper {
        width: 100%;

        input {
            width: 100%;
            height: auto;
            padding: 15px;
            background: #E3EFFD;
            border: none;
            border-bottom: 4px solid ${css.colors.blue};
        }

        textarea {
            width: 100%;
            height: 160px;
            padding: 15px;
            background: #E3EFFD;
            border: none;
            border-bottom: 4px solid ${css.colors.blue};
            font-family: inherit;
            font-size: inherit;
            outline: none;
        }

        &.error {
            input, textarea {
                border-color: ${css.colors.red};
            }
        }
    }

    &.valid {
        .input-wrapper input {
            padding-right: 50px;
        }
    }

    .select {
        div {
            background: #E3EFFD;
            width: 100%;
            justify-content: left;
            padding: 15px;
            border: none;
            border-bottom: 4px solid ${css.colors.blue};
        }
    }
`

const SuccessfulMessage = styled.div`
    width: 100%;
    background: #e3fdea;
    padding: 15px;
    margin-bottom: 30px;
    align-items: center;
    justify-content: space-between;
    border-bottom: 4px solid #24b929;
`

const Submit = styled.button`
    background: ${css.colors.blue};
    color: #FFFFFF;
    font-size: 18px;
    border: 1px solid ${css.colors.blue};
    padding: 15px 60px;
    margin: 0 auto;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
    }
`;

class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            phone: '',
            subject: '',
            description: '',
            contactMethod: '',
            isStudent: '',
            category: '',
            errors: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                description: '',
            },
            isValid: {
                name: false,
                email: false,
                phone: false,
                subject: false,
                description: false,
            },
        }
    }

    _onInputChange(key, value) {
        this.setState({
            errors: { ...this.state.errors, [key]: '' }
        });

        if (key === 'phone') {
            value = value.toString()
                .replace(/\s\s/g, ' ')
                .replace(/\+\+/g, '+')
                .replace(/--/g, '-')
                .replace(/[^\d\s()+-]/g, '')
        }

        this.setState({
            [key]: value,
        });
    }

    _validateInput(key) {
        const value = this.state[key];

        if (!value) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('fieldRequired') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        if (key === 'email' && !isValidEmail(value)) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('invalidEmail') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        if (key === 'phone' && value.toString().replace(/\D/g, '').length < 8) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('invalidPhoneNumber') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        this.setState(state => ({
            isValid: { ...state.isValid, [key]: true }
        }));

        return true;
    }

    _onSubmit(event) {
        event.preventDefault();

        const isValid = !Object.keys(this.state.isValid).filter(key => {
            return !this._validateInput(key);
        }).length;

        if (!isValid) {
            return;
        }

        $('#contact-form').attr('action', this.props.data.action);
        $('#contact-form').attr('method', 'POST');
        $('#contact-form').submit();
    }

    render() {
        const { data } = this.props;
        const { name, email, phone, description, subject, contactMethod, isStudent, category, errors, isValid } = this.state;
        const successful = new URLSearchParams(window.location.search).has('sendt');

        const contactOptions = [
            { name: 'Velg', value: '' },
            { name: 'Telefon', value: 'Phone' },
            { name: 'E-post', value: 'Email' }
        ];

        const studentOption = [
            { name: 'Velg', value: '' },
            { name: 'Ja', value: 'Yes' },
            { name: 'Nei', value: 'No' }
        ];

        const categoryOption = [
            { name: 'Velg', value: '' },
            { name: 'Rådgiver', value: 'Rådgiver' },
            { name: 'Administrasjon', value: 'Administration' },
            { name: 'IT', value: 'IT' },
            { name: 'Økonomi', value: 'Økonomi' }
        ];

        return (
            <Container flex wrap small={!data.show_sidebar} >
                <Form id="contact-form" className={data.show_sidebar ? 'has-sidebar' : ''}>
                    {successful && 
                        <SuccessfulMessage>
                            {data.successfulMessage}
                        </SuccessfulMessage>
                    }
                    <InputRow className={isValid.name ? 'valid' : ''}>
                        <Input label="Navn" name='name' value={name || ''} error={errors.name} onChange={e => this._onInputChange('name', e.target.value)} onBlur={() => this._validateInput('name')} />
                    </InputRow>
                    <InputRow valid={isValid.email}>
                        <Input label="E-post" name='email' value={email || ''} error={errors.email} onChange={e => this._onInputChange('email', e.target.value)} onBlur={() => this._validateInput('email')} />
                    </InputRow>
                    <InputRow className={isValid.phone ? 'valid' : ''}>
                        <Input label="Telefonnummer" name='phone' value={phone || ''} error={errors.phone} onChange={e => this._onInputChange('phone', e.target.value)} onBlur={() => this._validateInput('phone')} />
                    </InputRow>
                    <InputRow className={isValid.subject ? 'valid' : ''}>
                        <Input label="Emne" name='subject' value={subject || ''} error={errors.subject} onChange={e => this._onInputChange('subject', e.target.value)} onBlur={() => this._validateInput('subject')} />
                    </InputRow>
                    <InputRow className={isValid.description ? 'valid' : ''}>
                        <TextArea label="Din Melding" name='description' value={description || ''} error={errors.description} onChange={e => this._onInputChange('description', e.target.value)} onBlur={() => this._validateInput('description')} />
                    </InputRow>
                    <InputRow className={isValid.contactMethod ? 'valid' : ''}>
                        <label for={data.contactMethodFieldName}> Kontakt meg på </label>
                        <Select className='select' id={data.contactMethodFieldName} name={data.contactMethodFieldName} value={contactMethod || ''} options={contactOptions} onChange={e => this._onInputChange('contactMethod', e.target.value)} onBlur={() => this._validateInput('contactMethod')} />
                    </InputRow>
                    <InputRow className={isValid.isStudent ? 'valid' : ''}>
                        <label for={data.studentFieldName}> Er du elev hos oss </label>
                        <Select className='select' id={data.studentFieldName} name={data.studentFieldName} value={isStudent || ''} options={studentOption} onChange={e => this._onInputChange('isStudent', e.target.value)} onBlur={() => this._validateInput('isStudent')} />
                    </InputRow>
                    <InputRow className={isValid.category ? 'valid' : ''}>
                        <label for={data.categoryFieldName}> Kategori </label>
                        <Select className='select' id={data.categoryFieldName} name={data.categoryFieldName} value={category || ''} options={categoryOption} onChange={e => this._onInputChange('category', e.target.value)} onBlur={() => this._validateInput('category')} />
                    </InputRow>

                    <input type='hidden' name='orgid' value={data.organizationId} />
                    <input type='hidden' name='recordType' value={data.recordType} />
                    <input type='hidden' name='School' value='Bjørknes' />
                    <input type="hidden" name='external' value='1' />
                    <input type="hidden" name='retURL' value={window.location.href + '?sendt'}/>

                    <Submit onClick={this._onSubmit.bind(this)}> Send </Submit>
                </Form>

                {data.show_sidebar &&
                    <Sidebar>
                        <Html content>{data.content}</Html>
                    </Sidebar>
                }
            </Container>
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/partials/modules/Contact.js